import { render } from "./Cars.vue?vue&type=template&id=1fc3c0c8&scoped=true&ts=true"
import script from "./Cars.vue?vue&type=script&lang=ts"
export * from "./Cars.vue?vue&type=script&lang=ts"

import "./Cars.vue?vue&type=style&index=0&id=1fc3c0c8&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fc3c0c8"]])

export default __exports__